import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver dev overlay (does not affect production)
const resizeObserverErrHandler = (e) => {
  if (
    e.message &&
    (e.message.includes("ResizeObserver loop") ||
      e.message.includes("ResizeObserver loop completed with undelivered notifications"))
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};
window.addEventListener("error", resizeObserverErrHandler);
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason && typeof e.reason.message === "string" && e.reason.message.includes("ResizeObserver")) {
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
